import { render, staticRenderFns } from "./CedisModal.vue?vue&type=template&id=51282662"
import script from "./CedisModal.vue?vue&type=script&lang=js"
export * from "./CedisModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports